var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD991",
    stroke: "#F0BC5D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M9.604 2.412a.442.442 0 0 1 .792 0l1.925 3.9a1.77 1.77 0 0 0 1.329.966l4.305.63a.442.442 0 0 1 .245.754l-3.113 3.031a1.77 1.77 0 0 0-.51 1.565l.735 4.284a.442.442 0 0 1-.642.466l-3.848-2.023a1.77 1.77 0 0 0-1.645 0L5.33 18.008a.441.441 0 0 1-.642-.466l.734-4.283a1.77 1.77 0 0 0-.509-1.566L1.8 8.663a.442.442 0 0 1 .245-.756l4.304-.629a1.77 1.77 0 0 0 1.33-.966z"
  })));
};
export default SvgStar;